"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseDownloadUrlToJSONTyped = exports.ResponseDownloadUrlToJSON = exports.ResponseDownloadUrlFromJSONTyped = exports.ResponseDownloadUrlFromJSON = exports.instanceOfResponseDownloadUrl = void 0;
/**
 * Check if a given object implements the ResponseDownloadUrl interface.
 */
function instanceOfResponseDownloadUrl(value) {
    if (!('downloadUrl' in value) || value['downloadUrl'] === undefined)
        return false;
    return true;
}
exports.instanceOfResponseDownloadUrl = instanceOfResponseDownloadUrl;
function ResponseDownloadUrlFromJSON(json) {
    return ResponseDownloadUrlFromJSONTyped(json, false);
}
exports.ResponseDownloadUrlFromJSON = ResponseDownloadUrlFromJSON;
function ResponseDownloadUrlFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'downloadUrl': json['download_url'],
    };
}
exports.ResponseDownloadUrlFromJSONTyped = ResponseDownloadUrlFromJSONTyped;
function ResponseDownloadUrlToJSON(json) {
    return ResponseDownloadUrlToJSONTyped(json, false);
}
exports.ResponseDownloadUrlToJSON = ResponseDownloadUrlToJSON;
function ResponseDownloadUrlToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'download_url': value['downloadUrl'],
    };
}
exports.ResponseDownloadUrlToJSONTyped = ResponseDownloadUrlToJSONTyped;
